import Vue from 'vue';
import Vuex from 'vuex';

import createPersistedState from 'vuex-persistedstate';

import customers from './store/customers/customers';
import customerContactMoments from './store/customerContactMoments/customerContactMoments';
import companies from './store/companies/companies';
import users from './store/users/users';
import hours from './store/hours/hours';
import shifts from './store/shifts/shifts';
import documents from './store/documents/documents';
import organizations from './store/organizations/organizations';
import employments from './store/employments/employments';
import flexworkers from './store/flexworkers/flexworkers';
import leaveRequests from './store/leave-requests/leaveRequests';
import chats from './store/chats/chats';
import notifications from './store/notifications/notifications';
import root from './store/root/root';
import experiences from './store/experiences/experiences';
import costCenters from './store/costCenters/costCenters';
import certificates from './store/certificates/certificates';
import roles from './store/roles/roles';
import clientUsers from './store/clientUsers/clientUsers';
import blacklist from './store/blacklist/blacklist';
import metrics from './store/metrics/metrics'
import candidates from './store/candidates/candidates';
import candidateNotes from './store/candidateNotes/candidateNotes';
import candidateSickDays from './store/candidateSickDays/candidateSickDays';
import educations from './store/educations/educations';
import vacancies from './store/vacancies/vacancies';
import placements from './store/placements/placements';
import appointments from './store/appointments/appointments';
import VuexEasyFirestore from 'vuex-easy-firestore';
import smsHistory from './store/smsHistory/smsHistory';
import pools from './store/pools/pools';
import mailinglist from './store/mailinglist/mailinglist';
import workedHours from './store/workedHours/workedHours';
import sickLeaves from './store/sick-leaves/sickLeaves';

import contracts from './store/contracts/contracts'
import portalConfig from './store/portalConfig/portalConfig'

const easyFirestore = VuexEasyFirestore(
    [experiences, costCenters, roles, pools, mailinglist, workedHours, certificates, educations, candidates, candidateNotes, candidateSickDays, customers, vacancies, placements, appointments, blacklist, smsHistory, contracts, customerContactMoments, portalConfig], {
        logging: true,
        FirebaseDependency: Vue.prototype.$FB
    }
);
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        loading: false,
        oAuthToken: null,
    },
    getters: {
        getLoadingScreen: state => state.loading,
        getShowMenu: state => state.showMenu,
        getToken: state => state.oAuthToken,
        getAPICompanyID: (state) => {
            if (state.root.MockCompanyID > 0) {
                return state.root.MockCompanyID;
            } else {
                return state.users.me.company.id;
            }
        },
        getUserData: (state) => {
            return {
                id: state.users.me.id,
                firstname: state.users.me.firstname,
                lastname: state.users.me.lastname,
                email: state.users.me.email,
                departments: state.users.me.departments,
                selectedDepartment: state.users.me.selectedDepartment,
                rights: state.users.me.rights,
            };
        },
        getHourAppUser: state => state.users.hourAppUser,
        getRoles: state => state.roles,
    },
    mutations: {
        setLoading(state, payload) {
            state.loading = payload;
        },
        setOauthToken(state, payload) {
            state.oAuthToken = payload;
        }
    },
    actions: {
      async  closeApp({dispatch, commit, state}, payload) {
            commit('setLoading', true);
            //TODO: Is setting the first department, will need a selector
            let defaultDepartment = state.users.me.departments !== undefined ? state.users.me.departments[0] : {name: "Tilburg"};
            let selectedDepartment = {name: state.users.me.selectedDepartment}

           await Promise.allSettled([
                dispatch('candidates/closeDBChannel', {clearModule: true}),
                dispatch('customers/closeDBChannel', {clearModule: true}),
                dispatch('vacancies/closeDBChannel', {clearModule: true}),
                dispatch('placements/closeDBChannel', {clearModule: true}),
                dispatch('roles/closeDBChannel', {clearModule: true}),
                dispatch('customerContactMoments/closeDBChannel', {clearModule: true}),
                dispatch('portalConfig/closeDBChannel', {clearModule: true}),
            ]).then(async () => {
                dispatch('appointments/closeDBChannel', {clearModule: true}),
                    dispatch('blacklist/closeDBChannel', {clearModule: true}),
                    dispatch('experiences/closeDBChannel', {clearModule: true}),
                    dispatch('costCenters/closeDBChannel', {clearModule: true}),
                    dispatch('smsHistory/closeDBChannel', {clearModule: true}),
                    dispatch('certificates/closeDBChannel', {clearModule: true}),
                    dispatch('educations/closeDBChannel', {clearModule: true}),
                    dispatch('pools/closeDBChannel', {clearModule: true}),
                    dispatch('mailinglist/closeDBChannel', {clearModule: true}),
                    commit('setLoading', false);
            });
return true

        },
        initApp({dispatch, commit, state}, payload) {
            commit('setLoading', true);
            //TODO: Is setting the first department, will need a selector
            let defaultDepartment = {name: state.users.me.selectedDepartment}
             if (!defaultDepartment || state.users.me.departments.length < 2) {

                defaultDepartment = state.users.me.departments !== undefined ? state.users.me.departments[0] : {name: "Tilburg"};
            }

            console.log('SETTING TO', defaultDepartment.name)
            Promise.allSettled([
                dispatch('candidates/openDBChannel', {where: [['department', '==', defaultDepartment.name] ]}),
                dispatch('customers/openDBChannel', {
                    where: [['department', '==', defaultDepartment.name]]
                }),
                dispatch('vacancies/openDBChannel', {
                    orderBy: ['name'],
                    where: [['department', '==', defaultDepartment.name]]
                }),
                dispatch('placements/openDBChannel', {
                    // orderBy: ['id'],
                    where: [['department', '==', defaultDepartment.name]]
                }),
                dispatch('roles/openDBChannel', {
                    orderBy: ['id'],
                    // where: [['department', '==', defaultDepartment.name]]
                }),
                dispatch('pools/openDBChannel', {
                    orderBy: ['created_at'],
                    where: [['department', '==', defaultDepartment.name]]
                }),
            ]).then(async () => {
                dispatch('appointments/openDBChannel', {
                    orderBy: ['startDate'],
                    where: [['department', '==', defaultDepartment.name]]
                }),
                    dispatch('blacklist/openDBChannel', {
                        orderBy: ['created_at'],
                        where: [['department', '==', defaultDepartment.name]]
                    }),
                    dispatch('experiences/openDBChannel', {
                        orderBy: ['name'],
                        where: [['department', '==', defaultDepartment.name]]
                    });
                dispatch('costCenters/openDBChannel', {
                    where: [['department', '==', defaultDepartment.name]]
                });
                dispatch('smsHistory/openDBChannel', {where: [['department', '==', defaultDepartment.name]]}),
                    dispatch('certificates/openDBChannel', {
                        orderBy: ['name'],
                        where: [['department', '==', defaultDepartment.name]]
                    }),
                    dispatch('educations/openDBChannel', {
                        orderBy: ['name'],
                        where: [['department', '==', defaultDepartment.name]]
                    }),

                    dispatch('mailinglist/openDBChannel', {
                        orderBy: ['description'],
                        where: [['department', '==', defaultDepartment.name]]
                    }),
                    dispatch('contracts/openDBChannel', {
                        where: [['department', '==', defaultDepartment.name]]
                    }),
                    dispatch('customerContactMoments/openDBChannel'),
                    dispatch('portalConfig/openDBChannel')
                    dispatch('users/getAllUsers', {ApiClient: Vue.prototype.$ApiClient, departments: defaultDepartment}).then((res) => {
                    if (res.status === 200) {

                       let users = res.data.users.filter(user => user.hasOwnProperty('email'));
                         commit('users/setUsers', users)

                    }
                }).catch((err) => {


                });
                commit('setLoading', false);
            });
        }
    },
    modules: {
        companies,
        users,
        hours,
        shifts,
        documents,
        organizations,
        employments,
        flexworkers,
        leaveRequests,
        metrics,
        chats,
        notifications,
        sickLeaves,
        clientUsers,
        root // is always used for the motivaters (employees of motivate)
    },
    plugins: [createPersistedState({paths: ['oAuthToken', 'root']}), easyFirestore]
});